export default "__VITE_ASSET__c3a901b9__"